// Constant: Meta > Product name
const PRODUCT_NAME = 'aixplain'

// Export
export {
	PRODUCT_NAME
}
